import { ComponentConfig } from '@measured/puck';

import { Accordian, AccordianProps } from '../../../../components/molecules/accordian/accordian';

type AccordianBlockProps = {
  items: {
    item: { title: string; content: string | React.ReactNode };
  }[];
  textSize: AccordianProps['textSize'];
  titleLevel: AccordianProps['headerLevel'];
};

const AccordianBlock: ComponentConfig<AccordianBlockProps> = {
  label: 'Accordian',
  fields: {
    items: {
      type: 'array',
      arrayFields: {
        item: {
          type: 'object',
          objectFields: {
            title: { type: 'text' },
            content: { type: 'text' },
          },
        },
      },
    },
    titleLevel: {
      type: 'radio',
      options: [
        { label: 'Extra Small', value: 'xs' },
        { label: 'Small', value: 'sm' },
        { label: 'Medium', value: 'md' },
        { label: 'Large', value: 'lg' },
      ],
    },
    textSize: {
      type: 'radio',
      options: [
        { label: 'Extra Small', value: 'xs' },
        { label: 'Small', value: 'sm' },
        { label: 'Medium', value: 'md' },
        { label: 'Large', value: 'lg' },
      ],
    },
  },
  defaultProps: {
    items: [{ item: { title: 'Some title', content: 'Some generic content here.' } }],
    titleLevel: 'h4',
    textSize: 'md',
  },
  render: ({ titleLevel, items, textSize }: AccordianBlockProps) => {
    return (
      <Accordian
        headerLevel={titleLevel}
        items={items.map((item) => ({
          title: item.item.title,
          content: item.item.content,
        }))}
        textSize={textSize}
      ></Accordian>
    );
  },
};

export { AccordianBlock };

export type { AccordianBlockProps };
